
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function toggleOverflowHidden(summaryElement) {
  const detailsElement = summaryElement.parentNode;

  setTimeout(() => {
    if (detailsElement.hasAttribute('open')) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, 100); // Espera 1 segundo (1000 milisegundos) antes de ejecutar la lógica
}



const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  // console.log('hiiii',document.querySelectorAll('.js-youtube'))
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  details.classList.remove('menu-opening');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    // console.log(this, this.mainDetailsToggle)

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        this.mainDetailsToggle.classList.add('item-submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    this.mainDetailsToggle.classList.remove('item-submenu-open');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    this.mainDetailsToggle.classList.remove('item-submenu-open');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      console.log(this)
      const modal = document.querySelector(this.getAttribute('data-modal'));
      console.log(modal)
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      setTimeout(function () {
        deferredElement.contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', "*");
        deferredElement.contentWindow.postMessage('{"method":"play"}', "*");
      }, 1000);

      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

 onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true); // Si la variante no existe, deshabilita
      this.setUnavailable();
    } else {
      if (this.getAttribute("data-section") !== "section-quick-shop__id") {
        this.updateMedia();
        // this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      // Aquí habilitamos el botón si la variante es válida
      this.toggleAddButton(false, '', true);
    }
}


  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    //console.log(this.getVariantData());
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
  let hasTemplate = this.getAttribute("data-template");
  let url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`;
  if (hasTemplate) {
    url = `${this.dataset.url}?variant=${this.currentVariant.id}`
  }
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      let priceElements = document.querySelectorAll(`.price-${this.dataset.section}, .pdp-sticky-bar-price`);
      if(source && priceElements.length > 0){
        priceElements.forEach(element => {
          element.innerHTML = source.innerHTML;
          element.classList.remove('visibility-hidden');
        });
      }

      this.toggleAddButton(!this.currentVariant.available && customVariantObject[this.currentVariant.id]?.inventorypolicy === 'deny', window.variantStrings.soldOut);

      if (document.querySelector('.product__info-container .js-variant-radios .size_wrap .custom_size_main') ) {
        let curranthtml = document.querySelector('.product__info-container .js-variant-radios .size_wrap .custom_size_main');
        let curranthtmlInput = curranthtml.querySelectorAll('input');
        let previeshtml = html.querySelector('.product__info-container .js-variant-radios .size_wrap .custom_size_main');
        let previesInput = previeshtml.querySelectorAll('input');

        let previesInputMap = {};
        previesInput.forEach(input => {
          previesInputMap[input.id] = input;
        });
        curranthtmlInput.forEach(currInput => {
          let prevInput = previesInputMap[currInput.id];
          if (prevInput) {
            if (currInput.className !== prevInput.className) {
              currInput.className = prevInput.className;
            }
          }
        });
      }
      
      if(document.querySelector(".form__label .sizename").innerHTML = this.currentVariant.option2);
      if (document.querySelectorAll(".SoldOut")) {
        let soldOuttext = document.querySelectorAll(".SoldOut");
        soldOuttext.forEach(ele => {
          ele.innerHTML = "";
          ele.classList.remove("stok");
        });
        for (let variantId in customVariantObject) {
          if (variantId == this.currentVariant.id) {
            let inventoryQuantity = customVariantObject[variantId].inventoryquantity;
            let inventoryPolicy = customVariantObject[variantId].inventorypolicy;
            
            if (inventoryQuantity > 0 && inventoryQuantity <= 3) {
              soldOuttext.forEach(ele => {
                ele.innerHTML = "- Low in Stock";
                ele.classList.add("stok");
              });
            } else if (inventoryQuantity >= 4) {
              soldOuttext.forEach(ele => {
                ele.innerHTML = "";
                ele.classList.add("stok");
              });
            } else if (inventoryPolicy === 'continue') {
              soldOuttext.forEach(ele => {
                ele.innerHTML = "";
                ele.classList.add("stok");
              });
            } else {
              soldOuttext.forEach(ele => {
                ele.innerHTML = "- Sold Out";
                ele.classList.add("stok");
              });
            }
          }
        }
      }
    });
}


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
  
    // Apply styles to manage button visibility and state
    if (disable) {
      
      addButton.classList.add('hidden');
      addButton.setAttribute('disabled', 'disabled');
      
      // Show the Back in Stock button
      document.querySelectorAll('.stickyBISButton').forEach(btn => {
        btn.classList.remove('hidden');
      });
  
      // Hide all Sticky Add to Cart buttons
      document.querySelectorAll('.StickyAddToCart').forEach(button => {
        button.classList.add('hidden');
        button.querySelector('span').textContent = text;
        button.disabled = true;
      });
  
      // Display Back in Stock button
      productForm.querySelector('#BIS_trigger').style.display = "block";
    } else {
      
      addButton.classList.remove('hidden');
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
  
      // Hide the Back in Stock button
      productForm.querySelector('#BIS_trigger').style.display = "none";
  
      // Show all Sticky Add to Cart buttons
      document.querySelectorAll('.StickyAddToCart').forEach(button => {
        button.classList.remove('hidden');
        button.querySelector('span').textContent = window.variantStrings.addToCart;
        button.disabled = false;
      });
  
      // Hide Back in Stock buttons
      document.querySelectorAll('.stickyBISButton').forEach(btn => {
        btn.classList.add('hidden');
      });
    }
  
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    if (!Array.isArray(this.variantData)) this.variantData = this.variantData.variants;
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// /stickyBarButtons js// /stickyBarButtons js

let stickyBarButtons = document.querySelectorAll(".product_sticky_bar_button");
let stickyBarfaq = document.querySelectorAll(".product_sticky_bar_button_faq");
let reacommand = document.querySelectorAll(".product_sticky_bar_button_recommendations");
let imagewithtext = document.querySelectorAll(".product_sticky_bar_button_collectionlist");
let openAddElements = document.querySelectorAll(".open-add");
let reviewsection = document.querySelectorAll(".review_section");
let features = document.querySelectorAll(".product_sticky_bar_button_features");
let productStickyBarWrapMain = document.querySelector(".product_sticky_bar_wrap_main").offsetHeight;

// Function to hide buttons if no match is found
function checkAndHideButtonsOnLoad() {
  stickyBarButtons.forEach(button => {
    let sectionName = button.getAttribute('sectionnameButtton');
    if (sectionName) {
      let sectionNameNoSpacesLowercase = sectionName.replace(/\s+/g, '').toLowerCase();
      let matchFound = [...stickyBarfaq, ...reacommand, ...reviewsection, ...imagewithtext, ...features].some(element => {
        let elementSectionName = element.getAttribute('sectionsnamesame');
        return elementSectionName && elementSectionName.replace(/\s+/g, '').toLowerCase() === sectionNameNoSpacesLowercase;
      });
      if (!matchFound) {
        button.classList.add("hiddenbutton");
      }
    }
  });
}

// Helper function to scroll to the appropriate section
function scrollToSection(sectionElement, sectionOffset) {
  if (sectionElement) {
    window.scroll({
      top: sectionElement.offsetTop - sectionOffset,
      behavior: 'smooth'
    });
  }
}

// Event listener to handle button clicks
stickyBarButtons.forEach(button => {
  button.addEventListener('click', (event) => {
    let clickedButton = event.target;
    let sectionName = clickedButton.getAttribute('sectionnameButtton');

    // Remove "active" class from all buttons
    stickyBarButtons.forEach(btn => btn.classList.remove("active"));
    
    // Add "active" class to the clicked button
    clickedButton.classList.add("active");

    if (sectionName) {
      let sectionNameNoSpacesLowercase = sectionName.replace(/\s+/g, '').toLowerCase();
      
      // Close all open sections
      openAddElements.forEach(openElement => openElement.removeAttribute("open"));

      // Scroll to FAQ section
      stickyBarfaq.forEach((valueElement, index) => {
        let value = valueElement.getAttribute('sectionsnamesame');
        if (value && sectionNameNoSpacesLowercase === value.replace(/\s+/g, '').toLowerCase()) {
          openAddElements[index].setAttribute("open", "");  // Open the matched section
          scrollToSection(valueElement, productStickyBarWrapMain);  // Scroll to the section
        }
      });

      // Scroll to Recommendations section
      reacommand.forEach(recommendationElement => {
        let recoValue = recommendationElement.getAttribute('sectionsnamesame');
        if (recoValue && sectionNameNoSpacesLowercase === recoValue.replace(/\s+/g, '').toLowerCase()) {
          scrollToSection(recommendationElement, productStickyBarWrapMain);
        }
      });

      // Scroll to Features section
      features.forEach(featuresElement => {
        let featuresValue = featuresElement.getAttribute('sectionsnamesame');
        if (featuresValue && sectionNameNoSpacesLowercase === featuresValue.replace(/\s+/g, '').toLowerCase()) {
          scrollToSection(featuresElement, productStickyBarWrapMain);
        }
      });
       // Scroll to Review section
      reviewsection.forEach(reviewElement => {
        let reviewValue = reviewElement.getAttribute('sectionsnamesame');
        if (reviewValue && sectionNameNoSpacesLowercase === reviewValue.replace(/\s+/g, '').toLowerCase()) {
          scrollToSection(reviewElement, productStickyBarWrapMain);
        }
      });

      // Scroll to Image with Text section
      imagewithtext.forEach(imageTextElement => {
        let imgTextValue = imageTextElement.getAttribute('sectionsnamesame');
        if (imgTextValue && sectionNameNoSpacesLowercase === imgTextValue.replace(/\s+/g, '').toLowerCase()) {
          let scrollValueElement = document.querySelector(".collectionLists");
          if (scrollValueElement) {
            scrollToSection(scrollValueElement, productStickyBarWrapMain);
          }
        }
      });
    } else {
      console.error('No sectionName attribute found on the clicked button.');
    }
  });
});

// Initialize the button visibility on DOM load
document.addEventListener('DOMContentLoaded', () => {
  checkAndHideButtonsOnLoad();
});


// scoll stickyBarButton active 
// Function to handle adding/removing active classes based on section in view
// Function to handle adding/removing active classes based on section in view
function setActiveButton(sectionNameNoSpacesLowercase) {
  stickyBarButtons.forEach(button => {
    let buttonSectionName = button.getAttribute('sectionnameButtton');
    if (buttonSectionName) {
      let buttonSectionNameNoSpacesLowercase = buttonSectionName.replace(/\s+/g, '').toLowerCase();
      if (buttonSectionNameNoSpacesLowercase === sectionNameNoSpacesLowercase) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    }
  });
}

// Initialize IntersectionObserver with a lower threshold
let observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      let sectionName = entry.target.getAttribute('sectionsnamesame');
      if (sectionName) {
        let sectionNameNoSpacesLowercase = sectionName.replace(/\s+/g, '').toLowerCase();
        setActiveButton(sectionNameNoSpacesLowercase);
      }
    }
  });
}, {
  threshold: 0.5  // Adjust threshold to 0.5 for more consistent behavior
});

// Observe each section with class .product_sticky_bars
let sections = document.querySelectorAll('.product_sticky_bars');
sections.forEach(section => {
  observer.observe(section);
});

// scoll stickyBarButton active 

// /stickyBarButtons js// /stickyBarButtons js

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            QuickShop.prototype.bindBtnEvents();
            if (this.querySelector('.recommendations_slider')) {
              new Flickity(this.querySelector('.recommendations_slider'), {
                // options
                cellAlign: window.outerWidth <= 768 ? 'left' : "left",
                contain: true,
                wrapAround: true,
                pauseAutoPlayOnHover: false,
                autoPlay: false,
                prevNextButtons: true,
                pageDots: false,
                /*autoPlay: 5000,*/
                arrowShape: {
                  x0: 15,
                  x1: 60, y1: 45,
                  x2: 65, y2: 40,
                  x3: 25
                }
              });
            }
            if (this.querySelector('#complementary-slider')) {
              var slider = this.querySelector('#complementary-slider');
              if (slider) {
                new Flickity(slider, {
                  // options
                  cellAlign: 'left',
                  contain: true,
                  prevNextButtons: false,
                  pageDots: false
                });
              } else {
                console.error('Element with id complementary-slider-{{ section.id }} not found.');
              }

            }
            _bindCollectionEvents();
            window._bindLoadMoreEvents();
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent("swym:collections-loaded",{
                detail: {
                  id:this.id
                }
              }));
            }, 1000);
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// scollbuttonSize&Fit
let button = document.querySelector(".scollSizeFit");
let sectionscoll = document.querySelectorAll(".product_sticky_bar_button_faq");
let openadd = document.querySelectorAll(".open-add");
if (button) {
  button.addEventListener("click", function () {
    let getvalueButtonsectionname = button.getAttribute('data-section-sizefit');
    let SectionvalueNoSpacesLowercase = getvalueButtonsectionname.replace(/\s+/g, '').toLowerCase();
    openadd.forEach(openElement => {
      openElement.removeAttribute("open");
    });
    sectionscoll.forEach((valueElement, index) => {
      let value = valueElement.getAttribute('sectionsnamesame');
    if (value) {
      let valueNoSpacesLowercase = value.replace(/\s+/g, '').toLowerCase();
      if (SectionvalueNoSpacesLowercase === valueNoSpacesLowercase) {
        openAddElements[index].setAttribute("open", "");
        console.log(valueElement.offsetTop,"offsetTop")
        window.scroll({
          top: valueElement.offsetTop - productStickyBarWrapMain,
          behavior: 'smooth'
        });
      }
    }
  });
});
}
/// stStickyAddToCart js
if (document.querySelectorAll(".StickyAddToCart").length > 0) {
  let stickyAddToCartButtons = document.querySelectorAll(".StickyAddToCart");
  stickyAddToCartButtons.forEach(function(stickyAddToCartButton) {
    let clickButton = document.querySelector(".js-click-button");
    stickyAddToCartButton.addEventListener("click", function() {
      if (clickButton) {
        clickButton.click();
      }
    });
  });
}


